import { RecentActivityActionType, RecentActivityState } from './typings'

export const initState: RecentActivityState = {
  isLoading: false,
  response: null,
  recentTransactions: [],
  error: null
}

const recentActivityReducer = (
  // eslint-disable-next-line default-param-last, @typescript-eslint/default-param-last
  state: RecentActivityState = initState,
  action: RecentActivityActionType
): RecentActivityState => {
  switch (action.type) {
    case 'GET_RECENT_ACTIVITY':
      return {
        ...state,
        isLoading: true
      }
    case 'GET_RECENT_ACTIVITY_FULFILLED':
      return {
        ...state,
        isLoading: false,
        response: action.payload.response,
        recentTransactions: action.payload.recentTransactions
      }
    case 'GET_RECENT_ACTIVITY_FAILED':
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      }
    default:
      return state
  }
}

export default recentActivityReducer
